import firebase from 'firebase/app';
import 'firebase/auth';
import config from 'config';
import { IGetUser } from 'models/apiResponse/getUser';
import { FOUser } from 'models/dataStructures/FOUser';
import { ApiFail } from 'utils/ErrorService';
import { fetchRetry } from '../index';
import { getTokenHeader } from '../GetTokenHeader';

export const putMatchSentDocuments = async (
  matchId: string,
  sentDocuments: Record<string, string>,
): Promise<FOUser> => {
  const { currentUser } = firebase.auth();
  if (!currentUser) {
    throw new Error('No firebaseUID for user');
  }

  const tokenHeader = await getTokenHeader();
  const url = `${config.apiUrlV2}/matches/${matchId}/sentDocuments`;
  return fetchRetry(url, {
    method: 'PUT',
    headers: { ...tokenHeader, 'Content-Type': 'application/json' },
    body: JSON.stringify(sentDocuments),
  })
    .then(async (response) => {
      const responseJson = await response.json();
      return responseJson.data as IMatchData;
    })
    .catch((error) => {
      ApiFail(error);
      throw new Error(error);
    });
};
